@use '../../styling/colors.scss' as *;

.BackgroundColor {
  border-radius: inherit;
  height: 100%;

  &.ThemeSlider {
    background: $theme-color-slider-background;
  }

  &.ThemeSubBackground {
    background: $theme-color-sub-background;
  }

  &.ThemeTableHeaderBackground {
    background:  $theme-color-table-header-background;
  }

  &.ThemeReadOnly {
    background: $theme-color-input-readonly;
  }

  &.ThemeInformationBackground {
    background: $theme-information-external-background-color;
  }
}